import { Component, OnInit } from '@angular/core';
import { RegistrationService } from '../../registration.service';

import { FormGroup, FormControl, NgForm, Validators } from '@angular/forms';
import { forEach } from '@angular/router/src/utils/collection';
import swal from 'sweetalert2';
import { HandleError } from '../../shared/HandleError';

@Component({
  selector: 'app-bankinfo',
  templateUrl: './bankinfo.component.html',
  styleUrls: ['./bankinfo.component.css']
})
export class BankinfoComponent implements OnInit {
  isSainikExist: boolean = false;
  IFSC: any;
  SainikDetails: any;
  Banks: any;
  BankBranches: any;
  BankAccountOf: any;
  data: any;
  title = "Bank Details";
  s: any = {};
  sbd: any = {};
  formInvalid: boolean = false;
  mode: string = "save";
  UserName: string;
  RoleName: string;
  finalizeddata: any;
  Formdiable: boolean = false;
  Districts: any=[];


  constructor(private service: RegistrationService,private handleError:HandleError) {
  }

  ngOnInit() {
    this.GetallDistrictsForBankDetails();
    this.GetAllBanks();
    this.GetAllBankAccountOf();
    this.UserName=localStorage.getItem('userName');
    this.RoleName=localStorage.getItem('userRole');
    if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
    this.s.SR_ServiceNo=this.UserName;
    // this.GetSainikBasicDetails(this.s.SR_ServiceNo)
    this.GetSainikDetailsFromRegistration(this.s.SR_ServiceNo);
    this.GetfinalizeForBankInfo( this.UserName);
  }
  }
  GetfinalizeForBankInfo(SR_ServiceNo)
  {
    this.data = this.service.getfinalizeForBankInfo(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.finalizeddata=response;
        if(this.finalizeddata=='F')
       {
        this.Formdiable=true;
       }
      },
      (error) => {
        console.log(error);
      });
  }
  GetSainikDetailsFromRegistration(SR_ServiceNo: any) {
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForBanks(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.s.SR_Id = response.sainikRegistrationBasicDetails.SR_Id;
        this.s = response.sainikRegistrationBasicDetails;
        this.sbd.SBD_IsJoint = 'N';
        this.sbd.SBD_IsSameAsPension = 'N';
        this.sbd.SBD_RegistrationStatus = 'N';
        if (response.SainikBankDetails != null) {
          this.isSainikExist = true;
          this.mode = "update";
          this.sbd = response.SainikBankDetails;
          this.sbd.SBD_BA_Id_FK = this.sbd.Banks.BA_Id;
          this.GetAllBankBranches(this.sbd.Banks.BA_Id);
          this.sbd.SBD_BABR_Id_FK = this.sbd.BankBranches.BABR_Id;
          this.sbd.SBD_BAC_Id_FK = this.sbd.BankAccountOf.BAC_Id;
          this.sbd.SBD_IsSameAsPension = response.SainikBankDetails.SBD_IsSameAsPension;
          if (response.SainikBankDetails.SBD_IsSameAsPension == 'Y')
            this.sbd.SBD_IsSameAsPension = "Y";
        }
        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400)
          //swal('Warning!', 'Sainik does not exist.', 'warning');
          //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
          swal('Warning!', 'Please fill all the Details.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }
  GetAllBanks() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllBanks();
    this.data.subscribe(
      (response) => {
        this.Banks = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetAllBankBranches(BankId) {
    if (BankId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getAllBankBranches(BankId);
      this.data.subscribe(
        (response) => {
          this.BankBranches = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.sbd.SBD_BA_Id_FK = undefined;
      this.sbd.SBD_BABR_Id_FK = undefined;
      this.sbd.SBD_IFSC = "";
    }
  }

  GetIFSC(BranchId) {
    if (BranchId != undefined) {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getIFSC(BranchId);
      this.data.subscribe(
        (response) => {
          this.IFSC = response;
          this.sbd.SBD_IFSC = response.BABR_IFSC;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
    }
    else {
      this.sbd.SBD_BABR_Id_FK = undefined;
      this.sbd.SBD_IFSC = "";
    }
  }

  GetAllBankAccountOf() {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getAllBankAccountOf();
    this.data.subscribe(
      (response) => {
        this.BankAccountOf = response;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetSainikBasicDetails(SR_ServiceNo: any) {
    this.isSainikExist = false;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.getSainikBasicDetailsForBanks(SR_ServiceNo);
    this.data.subscribe(
      (response) => {
        this.s.SR_Id = response.sainikRegistrationBasicDetails.SR_Id;
        this.s = response.sainikRegistrationBasicDetails;
        // this.sbd.SBD_IsJoint = 'N';
        // this.sbd.SBD_IsSameAsPension = 'N';
        // this.sbd.SBD_RegistrationStatus = 'N';
        if (response.SainikBankDetails != null) {
          this.isSainikExist = true;
          this.mode = "update";
          this.sbd = response.SainikBankDetails;
          this.sbd.SBD_BA_Id_FK = this.sbd.Banks.BA_Id;
          this.GetAllBankBranches(this.sbd.Banks.BA_Id);
          this.sbd.SBD_BABR_Id_FK = this.sbd.BankBranches.BABR_Id;
          this.sbd.SBD_BAC_Id_FK = this.sbd.BankAccountOf.BAC_Id;
          this.sbd.SBD_IsSameAsPension = response.SainikBankDetails.SBD_IsSameAsPension;
          if (response.SainikBankDetails.SBD_IsSameAsPension == 'Y')
            this.sbd.SBD_IsSameAsPension = "Y";
        }
        //  this.s.SR_ServiceType=response.sainikRegistrationBasicDetails.ServiceTypes.SR_ServiceType;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        if (error.status == 400){
         if(this.RoleName=="Super Admin"){
          swal('Warning!', 'Sainik does not exist, Please fill the details', 'warning');
          }
          else{
            swal('Warning!', 'Sainik does not belong to this district or Sainik does not exist', 'warning');
           }
          } 
          //swal('Warning!', 'Sainik does not exist.', 'warning');
          //swal('Warning!', 'Sainik does not belong to this district.', 'warning');
        // else if(error.status == 401)
        //   swal('Warning!', 'Not authorized to access this page.', 'warning');
        this.handleError.ErrorHandler(error);
      });
  }

  SaveSainikBankDetails(sainikId, bd: NgForm) {
     if (bd.valid) {
    let inputChar = new Number(bd.controls["SBD_AccountNo"].value);
    if (inputChar==0)
    {
      swal("warning!","Please enter valid account number.");
      this.formInvalid = true;
    }
    else
    {
    this.formInvalid = false;
    // if( bd.value.SBD_IsSameAsPension==null)
    // bd.value.SBD_IsSameAsPension="Y";
    // if( bd.value.SBD_IsJoint==null)
    // bd.value.SBD_IsJoint="Y";
    // if( bd.value.SBD_RegistrationStatus==null)
    // bd.value.SBD_RegistrationStatus="Y";
    bd.value.SBD_IFSC = this.sbd.SBD_IFSC;
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.service.saveSainikBankDetails(sainikId, bd.value);
    this.data.subscribe(
      (response) => {
        console.log(bd);
        if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){
          this.GetSainikDetailsFromRegistration(this.UserName);
        }
        else{
        bd.reset();
        bd.resetForm();
        this.s.SR_ServiceType="";
        this.s.SR_Category="";
        this.s.SR_Name="";
        this.s.SR_SurName="";
        }
        this.formInvalid = false;
        swal('Success!', 'Sainik Bank details has been saved successfully.', 'success');
        document.getElementById('loader-spinner').style.display = "none";
        // window.location.href='http://sainik.esdinfra.com/index.html#/';
      }, (error) => {
        console.log(error);
        document.getElementById('loader-spinner').style.display = "none";
        this.handleError.ErrorHandler(error);
      });
      }
    }
     else{
      // swal('Warning!','There are errors, please correct the errors and try again.','warning');
    swal('Warning!', 'Please fill the mandatory(*) fields.', 'warning');
    this.formInvalid = true;
    }
  }


  ClearForm(){
         this.s.SR_ServiceType="";
          this.s.SR_Category="";
          this.s.SR_Name="";
          this.s.SR_SurName="";
  }

  UpdateSainikBankDetails(sainikId, bd: NgForm) {
    if (bd.valid) {
      let inputChar = new Number(bd.controls["SBD_AccountNo"].value);
      if (inputChar==0)
      {
        swal("warning!","Please enter valid Bank Account Number.");
        this.formInvalid = true;
      }
      else
      {
      this.formInvalid = false;
      bd.value.SBD_IFSC = this.sbd.SBD_IFSC;
      document.getElementById('loader-spinner').style.display = "block";      
      this.data = this.service.updateSainikBankDetails(sainikId, bd.value);
      this.data.subscribe(
        (response) => {
          console.log(bd);
          if(this.RoleName=='sainik'|| this.RoleName=='Sainik'){            
            this.GetSainikDetailsFromRegistration(this.UserName);
          }
          else{
          bd.reset();
          bd.resetForm();
          this.s.SR_ServiceType="";
          this.s.SR_Category="";
          this.s.SR_Name="";
          this.s.SR_SurName="";
          }
          this.formInvalid = false;
          swal('Success!', 'Sainik Bank details has been updated successfully.', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          // window.location.href='http://sainik.esdinfra.com/index.html#/';
        }, (error) => {
          console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
          this.handleError.ErrorHandler(error);
        });
    }
  }
    else {
      swal('Warning!', 'There are errors, please correct the errors and try again.', 'warning');
      this.formInvalid = true;
    }
  }


  //District dropdown
  GetallDistrictsForBankDetails() {
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.service.getallDistrictsForBankDetails();
      this.data.subscribe(
        (response) => {
          this.Districts = response;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          //console.log(error);
          document.getElementById('loader-spinner').style.display = "none";
        });
  }

}



// WEBPACK FOOTER //
// ./src/app/sainik-registration/bankinfo/bankinfo.component.ts